import React from "react";
import { QuestionType } from "ewoq/containers/Interrogator";
import * as Radio from "ewoq/prototypes/Radio";
import * as Slider from "ewoq/prototypes/Slider";

import { kss } from "Questionnaires/StandardQuestionComponents/KSS";
import { fourEnergiesPresent } from "Questionnaires/StandardQuestionComponents/FourEnergies";
import {
  feelings,
  extraFeelings
} from "Questionnaires/StandardQuestionComponents/Feelings";

const questions: QuestionType[] = [
  {
    id: "CS_1",
    plainTitle: "KSS sleepiness:",
    title: (
      <span>Please indicate your sleepiness over the past 10 minutes: </span>
    ),
    component: v => kss(v)
  },
  {
    id: "CS_2",
    plainTitle: "Energy levels:",
    title: <span>How do you feel: </span>,
    component: v => fourEnergiesPresent(v)
  },
  {
    id: "CS_3.1",
    plainTitle: "Alertness:",
    title: (
      <span>
        How alert are you? How quickly do you feel you would respond to
        something (e.g. a ball thrown at your head)?
      </span>
    ),
    component: v => (
      <Slider.Question
        onValid={v}
        sliderType={Slider.SliderType.horizontal}
        labels={["Slow, sluggish", "Normal", "Hyperalert"]}
      />
    )
  },
  {
    id: "CS_3.2",
    plainTitle: "Focus:",
    title: <span>How focused / concentrated are you at the moment?</span>,
    explanation:
      "Imagine you are in a lecture, how capable would you be of paying attention?",
    component: v => (
      <Slider.Question
        onValid={v}
        sliderType={Slider.SliderType.horizontal}
        labels={["Very unfocused", "Very concentrated"]}
      />
    )
  },
  {
    id: "CS_4",
    plainTitle: "Sleep pressure:",
    title: <span>How much need do you feel to fall asleep right now?</span>,
    component: v => (
      <Radio.Question
        onValid={v}
        options={[
          { text: "I can't sleep right now" },
          { text: "I would have a hard time falling asleep" },
          { text: "I might sleep" },
          { text: "I would like to sleep" },
          { text: "I really want to sleep" },
          { text: "This is the most I've ever wanted to sleep" },
          { text: "I feel tired, but I don't think I could sleep" }
        ]}
      />
    )
  },
  {
    id: "CS_5_1",
    mandatory: false,
    plainTitle: "General feelings:",
    title: <span>What is your mood right now?</span>,
    component: v => (
      <Slider.Question
        onValid={v}
        sliderType={Slider.SliderType.horizontal}
        labels={["Very bad", "Very good"]}
      />
    )
  },
  {
    id: "CS_5_2",
    mandatory: false,
    plainTitle: "Feelings:",
    title: (
      <span>Indicate on the following scales how you feel right now: </span>
    ),
    component: v => feelings(v)
  },
  {
    id: "CS_5_3",
    mandatory: true,
    title: "Do you feel...",
    plainTitle: "Stress:",
    component: v => (
      <Slider.Question
        onValid={v}
        sliderType={Slider.SliderType.horizontal}
        labels={["Relaxed", "Tense", "Stressed"]}
      />
    )
  },
  {
    id: "CS_6",
    mandatory: false,
    plainTitle: "Extra feelings:",
    title: <span>Check all that apply: </span>,
    component: v => extraFeelings(v)
  },
  {
    id: "CS_7",
    mandatory: false,
    plainTitle: "Emotional control:",
    title: (
      <span>
        How much control do you feel you have on your emotions right now?
      </span>
    ),
    component: v => (
      <Slider.Question
        onValid={v}
        sliderType={Slider.SliderType.horizontal}
        labels={["None", "Some", "Excellent"]}
      />
    )
  },
  {
    id: "CS_8",
    plainTitle: "Motivation:",
    title: (
      <span>
        How motivated are you at the moment to carry out the following tests?
      </span>
    ),

    component: v => (
      <Slider.Question
        onValid={v}
        sliderType={Slider.SliderType.horizontal}
        labels={["Not motivated at all", "Extremely motivated"]}
      />
    )
  }
];
export default questions;
